import { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import TextField from '@mui/material/TextField';
import RadioInput from './RadioButton';

const RadioButton = (props) => {
  // const { change } = props;
  // // const [value, setValue] = useState();
  // console.log(props);

  // const changeHandler = (event, option) => {
  //   console.log(JSON.stringify(event.target.value), JSON.stringify(option));
  //   // setValue(val);
  //   return change(option);
  // };

  // const options = props.options.map(option => (
  //   <label key={option.id}>
  //     <Field
  //       name={props.name}
  //       component="input"
  //       type="radio"
  //       value={option.value}
  //       // onChange={(event, option) => { changeHandler(event, option) }}
  //     />{' '}
  //     {option.label}
  //   </label>
  // ))
  // return options;

  const { id, name, type, typeName, order, options, required, fieldState } = props;
  const [checkedOption, setCheckedOption] = useState();
  const [value, setValue] = useState();

  useEffect(() => {
    if (options?.length > 0) {
      // const option = props.options.find(option => option.default);
      let defaultOption;
      let customOption;

      for (const option of options) {
        if (option.default) {
          defaultOption = { ...option };
        }
        if (option.typeName === 'CUSTOM_OPTION') {
          // customOption = { ...option };
          setValue(option.value);
        }
      }

      if (defaultOption) {
        setCheckedOption(defaultOption);
        setValue(defaultOption.value);
      }
    }
  }, []);

  const changeHandler = (event) => {
    setValue(event.target.value);
    if (checkedOption?.typeName === "CUSTOM_OPTION") {
      const newOption = { ...checkedOption }
      newOption.value = event.target.value;
      setCheckedOption(newOption);
    }
  }

  return (
    <div>
      <Field
        id={id}
        name={name}
        typeName={typeName}
        order={order}
        options={options}
        component={RadioInput}
        customValue={value}
        checkedOption={checkedOption}
        setCheckedOption={(option) => setCheckedOption(option)}
      />
      {fieldState?.result?.typeName === 'CUSTOM_OPTION' &&
        <TextField
          size="small"
          name={`${props.name}_custom_option`}
          fullWidth
          value={value || ""}
          onChange={(event) => { changeHandler(event); }}
        />
        // <input
        //   type="text"
        //   style={{ height: 35, width: '50%', marginTop: 5, padding: 10, fontSize: 14 }}
        //   name={`${props.name}_custom_option`}
        //   value={value}
        //   onChange={(event) => {
        //     changeHandler(event);
        //   }}
        // />
      }
    </div>
  );

}

export default RadioButton;